<h2 class="landing-cuisines-header">{{ 'discover_cuisines' | translate }}</h2>
<ul class="landing-cuisines-list">
  <li *ngFor="let cuisine of cuisines" class="landing-cuisines-list-item">
    <a [routerLink]="['/delivery/kouzines/', cuisine.key]" class="landing-cuisines-list-anchor">{{ cuisine.name }}</a>
  </li>
</ul>
